import { LegalPage } from "./LegalPage";

export function TermsAndConditions() {
  return (
    <LegalPage title="Terms of Service" updated="28 April 2026">
      <p>
        Please read these Terms carefully before using the Ammayum Kunjum app or
        website (the "Service"). By creating an account or using the Service,
        you agree to be bound by these Terms.
      </p>

      <h2>1. About Ammayum Kunjum</h2>
      <p>
        Ammayum Kunjum is a discovery and booking platform for postnatal and
        prenatal care homes in Kerala, India.
      </p>
      <blockquote>
        <strong>
          We are a marketplace — we do not provide care ourselves.
        </strong>{" "}
        All care is provided by independent care homes ("Providers"). Nothing on
        the Service is medical advice.
      </blockquote>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old and a resident of India to use the
        Service.
      </p>

      <h2>3. Accounts</h2>
      <ul>
        <li>Keep your OTP confidential — do not share your account.</li>
        <li>Provide accurate information in your profile.</li>
        <li>We may suspend accounts that violate these Terms.</li>
      </ul>

      <h2>4. Bookings and Payments</h2>
      <ul>
        <li>
          <strong>Payments go directly to Providers.</strong> Ammayum Kunjum
          does not collect or process your payment.
        </li>
        <li>
          Confirmations are subject to the Provider's acceptance and
          availability.
        </li>
        <li>
          Cancellation policies are set by each Provider — review them before
          booking.
        </li>
        <li>
          We are not responsible for financial disputes between you and a
          Provider.
        </li>
      </ul>

      <h2>5. Provider Vetting</h2>
      <p>Providers are visited and verified at onboarding. However:</p>
      <ul>
        <li>
          Verification does not guarantee quality, safety, or suitability for
          your needs.
        </li>
        <li>
          Providers may change staff, facilities, or practices after
          verification.
        </li>
        <li>
          You are responsible for assessing whether a Provider suits your
          requirements.
        </li>
      </ul>

      <h2>6. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Post false, misleading, or defamatory reviews</li>
        <li>Harass or harm any Provider or user</li>
        <li>Use automated tools or scrapers on the Service</li>
        <li>Use the Service for any unlawful purpose</li>
      </ul>

      <h2>7. Provider Terms</h2>
      <p>Providers additionally agree to:</p>
      <ul>
        <li>
          Provide accurate information about facilities, staff, and pricing
        </li>
        <li>Maintain standards represented during verification</li>
        <li>Respond to booking requests within displayed timeframes</li>
        <li>Honour confirmed bookings unless mutually cancelled</li>
        <li>
          Comply with applicable Indian healthcare and consumer protection laws
        </li>
      </ul>

      <h2>8. Health Information</h2>
      <p>
        Health details you enter personalise your experience only. Always
        consult a qualified healthcare professional for medical decisions.
      </p>

      <h2>9. Intellectual Property</h2>
      <p>
        All content, logos, and software are owned by Ammayum Kunjum or its
        licensors. You may not reproduce or distribute them without written
        permission. Your submitted content (reviews, photos) remains yours; you
        grant us a licence to display it on the platform.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Ammayum Kunjum is not liable
        for:
      </p>
      <ul>
        <li>
          The quality, safety, or outcome of care provided by any Provider
        </li>
        <li>Losses from booking cancellations or Provider non-performance</li>
        <li>
          Indirect or consequential damages arising from use of the Service
        </li>
      </ul>
      <p>
        Our total liability shall not exceed ₹5,000 or the amount you paid us in
        the three months preceding the claim, whichever is greater.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Disputes are subject to
        the exclusive jurisdiction of the courts in Ernakulam, Kerala.
      </p>

      <h2>12. Changes to These Terms</h2>
      <p>
        We will notify you of material changes at least 14 days in advance.
        Continued use after the effective date constitutes acceptance.
      </p>

      <h2>13. Contact</h2>
      <p>
        <strong>Ammayum Kunjum</strong> · Malappuram, Kerala, India
        <br />
        Email:{" "}
        <a href="mailto:legal@ammayumkunjum.com">legal@ammayumkunjum.com</a>
        <br />
        Phone: <a href="tel:+919562492181">+91 95624 92181</a>
      </p>
    </LegalPage>
  );
}
